import styled from 'styled-components'

export const WebsiteLanguageSwitcherUi = styled.div``
